module.exports = __webpack_public_path__ + "img/nota-folio-el-eden.1cdfdb9b.png";